import { Flex, Text } from "@chakra-ui/react";

export default function SFTPInformation() {
	return (
		<Flex direction='column' pt={'20px'}>
			<Text>A Secure File Transfer Protocol</Text>
		</Flex>
	)
}